<template>
  <div>
    <app-header v-if="authenticated"></app-header>
    <router-view></router-view>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import appHeader from '../Header/Header';

  export default {
    name: 'app-layout',
    components: {
      appHeader,
    },
    computed: mapGetters(['authenticated']),
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// Layout.vue?bdd94bcc